// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_CHECKOUT_PRODUCT_RESERVED_BY_username_SEE_DETAILS_link = "%(username)s si objednal toto zbo\u017e\u00ed. Zobraz %(link)s";
export const BAZAAR_CHECKOUT_SEE_RESERVATION_DETAILS = "pr\u016fb\u011bh objedn\u00e1vky";
export const BZ2_NEW_MESSAGE = "Nov\u00e1 zpr\u00e1va";
